const SOCIAL_HOSTS = Object.freeze({
  vk: new Set(['vk.com', 'www.vk.com']),
  max: new Set(['max.ru', 'www.max.ru'])
});
function isAllowedSocialUrl(value, network) {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (trimmed === '') return true;
  if (trimmed.length > 500 || !SOCIAL_HOSTS[network]) return false;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'https:' && SOCIAL_HOSTS[network].has(url.hostname.toLowerCase()) &&
      url.username === '' && url.password === '' && (url.port === '' || url.port === '443');
  } catch (error) { return false; }
}
function preserveLegacySocialFields(sanitizedSocial, existingSocial) {
  const result = { ...sanitizedSocial };
  const existing = existingSocial && typeof existingSocial === 'object' ? existingSocial : {};
  for (const field of ['linkedin', 'github', 'twitter', 'instagram']) {
    if (typeof existing[field] === 'string') result[field] = existing[field];
  }
  return result;
}
function getVisibleSocialLinks(contact = {}, social = {}) {
  social = social && typeof social === 'object' ? social : {};
  return [
    { key: 'vk', url: social.vk, label: 'ВКонтакте', icon: 'vk' },
    { key: 'max', url: social.max, label: 'MAX', icon: 'max' }
  ].filter((link) => typeof link.url === 'string' && link.url.trim() !== '' && isAllowedSocialUrl(link.url, link.key));
}
module.exports = { getVisibleSocialLinks, isAllowedSocialUrl, preserveLegacySocialFields };
